var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": 40,
            "min-height": 50,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "div",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [_c("span", [_vm._v("Advance Payment Entry")])]
            ),
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _c("payment-entry-advance-payment", {
                attrs: {
                  "is-new-entity": _vm.isNewEntity,
                  "show-amount": _vm.showAmount,
                  "read-only-view": _vm.readOnlyView,
                },
                model: {
                  value: _vm.entity,
                  callback: function ($$v) {
                    _vm.entity = $$v
                  },
                  expression: "entity",
                },
              }),
            ],
            1
          ),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.entity.isNew,
                      expression: "entity.isNew",
                    },
                  ],
                  staticClass: "button is-success tooltip",
                  attrs: { "data-tooltip": "Save" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", { staticClass: "mdi mdi-content-save mdi-18px" }),
                  ]),
                  _c("span", [_vm._v("Save")]),
                ]
              ),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.entity.isNew,
                      expression: "!entity.isNew",
                    },
                  ],
                  staticClass: "button is-primary tooltip",
                  attrs: { "data-tooltip": "Print" },
                  on: {
                    click: function ($event) {
                      return _vm.print()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", { staticClass: "mdi mdi-printer mdi-18px" }),
                  ]),
                  _c("span", [_vm._v("Print")]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "button tooltip",
                  attrs: { "data-tooltip": "Close" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }